import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/STATUSES';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    institutionId => ({institutionId}),
    statuses => ({statuses}),
);

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAction(
    `${domain}/CREATE`,
    (institutionId, icon, color, title) => ({institutionId, icon, color, title}),
    status => ({status}),
);

export const {
    action: remove,
    success: removeSuccess,
    failed: removeFailed,
} = createAction(
    `${domain}/REMOVE`,
    statusConfigId => ({statusConfigId}),
    statusConfigId => ({statusConfigId}),
    statusConfigId => ({statusConfigId}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    (statusConfigId, icon, color, title) => ({statusConfigId, icon, color, title}),
    status => ({status}),
    statusConfigId => ({statusConfigId}),
);

export const {
    action: applyStatus,
    success: applyStatusSuccess,
    failed: applyStatusFailed,
} = createAction(
    `${domain}/APPLY_STATUS`,
    (statusConfigId, childIds, employeeIds) => ({statusConfigId, childIds, employeeIds}),
    (statusConfigId, childIds, employeeIds) => ({statusConfigId, childIds, employeeIds}),
);

export const {
    action: endStatus,
    success: endStatusSuccess,
    failed: endStatusFailed,
} = createAction(
    `${domain}/END_STATUS`,
    (statusConfigId, childIds, employeeIds) => ({statusConfigId, childIds, employeeIds}),
    (statusConfigId, childIds, employeeIds) => ({statusConfigId, childIds, employeeIds}),
    statusConfigId => ({statusConfigId}),
);
